import { data } from '../../svg/Webhook/data';
import { makeIcon } from '../makeIcon';

export const Webhook = makeIcon(data, 'webhook', 'Webhook');

export default Webhook;
